module.exports = __webpack_public_path__ + "img/a-china.e8d23fa7.svg";